import React from "react"
import Ffmpeg from "../../containers/Ffmpeg/Ffmpeg"
import Row from "react-bootstrap/Row"
import { Col, Container } from "react-bootstrap"
import "./FfmpegPage.css"

function FfmpegPage() {
  return (
    <Container fluid>
      <Row>
        <Col xs={1}></Col>

        <Col xs={10} style={{ textAlign: "center" }}>
          <h1 className="my-3" id="ffmpeg-page-title">
            FFmpeg Online
          </h1>
          <h4 className="mt-1">Run FFmpeg entirely in your browser!</h4>
          <div className="my-5">
            <Ffmpeg></Ffmpeg>
          </div>
        </Col>
        <Col xs={1} />
      </Row>
      <Row
        style={{
          justifyContent: "center",
        }}
      >
        <a className="mb-3" href="mailto: esk@etggames.com">
          Contact Us
        </a>
      </Row>
    </Container>
  )
}

export default FfmpegPage
